<div class="ft-form">
    <div class="about-us-container">
        <div class="about-us">
            <div class="logo"></div>
            <h4 id="about-us-app-title" class="title">{{"about_us.about_embla.lbl_app_title" | translate}}</h4>
            <h5>{{"lbl_version" | translate}} <span id="about-us-version">{{appVersion}}</span></h5>
            <h5 id="about-us-copyright" class="copyright">&copy; 1996&nbsp;–&nbsp;{{ currentYear }} {{'about_us.about_embla.lbl_copyright' | translate}}&nbsp;&nbsp;&nbsp;</h5>
            <span class="support">{{"about_us.about_embla.lbl_support" | translate}} : <a id="about-us-support-link" href="mailto:hei@embla.no">firmapost@embla.no</a></span>
        </div>
    </div>
    <div class="footer">
        <button id="about-us-ok" class="ft-btn ft-btn-active-not-selected" (click)="ok()">{{"lbl_ok" | translate}}</button>
    </div>
</div>